<template>
  <div :class="cardWrapperClass">
    <div :class="iconWrapperClass">
      <i :class="iconClass"></i>
    </div>
    <div class="alert-card__body">
      <div class="alert-card__header">{{ header }}</div>
      <div class="alert-card__text">
        {{ message }}
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
var possibleCardTypes = ['success', 'error'];
export default {
  name: 'AlertCard',
  props: ['type', 'header', 'message'],
  computed: {
    getType: function () {
      if (!possibleCardTypes.includes(this.type)) {
        return 'success';
      }
      return this.type;
    },
    cardWrapperClass: function () {
      var classObj = {
        'alert-card': true,
      };
      classObj[`alert-card--${this.getType}`] = true;
      return classObj;
    },
    iconClass: function () {
      if (this.getType === 'error') {
        return 'fas fa-exclamation-circle';
      }
      //  default type: success
      return 'fas fa-check-circle';
    },
    iconWrapperClass: function () {
      var classObj = {
        'alert-card__icon': true,
      };
      classObj[`alert-card__icon--${this.getType}`] = true;
      return classObj;
    },
  },
};
</script>

<style>
</style>